import { getCompliantLocalStorageItem } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/selectors';
import { CompliantLocalStorageKeys } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/constants';
import { setCompliantLocalStorageItem } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/actions';
import { all, call, fork, put, select, take, takeLatest } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { eventChannel } from 'redux-saga';
import { hydrateStorage, saveEnterHandling, saveGoodState } from '../actions/storage';
import { getStorageSlice } from '../selectors/storage';
import { hydrateDraft } from '../actions/drafts';
import { getDraftSlice } from '../selectors/drafts';
import { DamzState } from '../../types';
import { DEFAULT_DRAFT_STATE } from '../helpers';

type LocalStorageState = {
  damz?: {
    storage?: DamzState['storage'];
    draft?: DamzState['drafts'];
  };
};

function* loadStorage() {
  try {
    const chatDB = yield select(getCompliantLocalStorageItem, CompliantLocalStorageKeys.CHATDB);
    const state: LocalStorageState = JSON.parse(chatDB || '{}');
    if (state && state.damz) {
      ddt.log('damz', 'Loading LS', state.damz);
      yield put(hydrateStorage(state.damz.storage));
      yield put(hydrateDraft(state.damz.draft ?? DEFAULT_DRAFT_STATE));
    }
  } catch (e) {
    ddt.error('damz', 'Failed to hydrate localstorage', e);
  }
}

function* writeStorage() {
  try {
    const chatDB = yield select(getCompliantLocalStorageItem, CompliantLocalStorageKeys.CHATDB);
    const storageState: DamzState['storage'] = yield select(getStorageSlice);
    const draftState: DamzState['drafts'] = yield select(getDraftSlice);

    const state = JSON.parse(chatDB || '{}');
    state.damz = {
      storage: storageState,
      draft: {
        participants: draftState.participants,
        messages: draftState.messages,
      },
    };
    ddt.log('damz', 'Writing LS', state.damz);

    yield put(
      setCompliantLocalStorageItem({
        key: CompliantLocalStorageKeys.CHATDB,
        value: JSON.stringify(state),
      })
    );
  } catch (e) {
    ddt.error('damz', 'Failed to hydrate localstorage', e);
  }
}

function* watchUnload() {
  const channel = eventChannel(emitter => {
    const handler = () => emitter('beforeunload');
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  });
  while (true) {
    yield take(channel);
    yield call(writeStorage);
  }
}

/**
 * Handles LS
 */
export function* localStorageSaga() {
  yield loadStorage();
  yield fork(watchUnload);
  yield all([takeLatest([saveEnterHandling, saveGoodState], writeStorage)]);
}
